require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-aria/index.js
// module id = 667
// module chunks = 6